import { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  es: {
    // Navbar
    nav_inicio: 'Inicio',
    nav_excursiones: 'Excursiones',
    nav_reservar: 'Reservar',
    nav_admin: 'Administración',
    nav_contacto: 'Contacto',
    nav_whatsapp: 'Reservar WhatsApp',
    
    // Hero
    hero_subtitle: 'Bienvenidos al Caribe',
    hero_title: 'Excursiones Inolvidables en República Dominicana',
    hero_description: 'Transporte seguro, guías expertos y experiencias premium. Descubre las playas más hermosas del Caribe.',
    hero_btn_tours: 'Ver Excursiones',
    hero_btn_reserve: 'Reservar Ahora',
    
    // Tours
    tours_title: 'Nuestras Excursiones',
    tours_subtitle: 'Explora el Caribe Dominicano',
    tours_description: 'Descubre las mejores excursiones en República Dominicana. Playas paradisíacas, aventuras, cultura y mucho más.',
    tours_search: 'Buscar excursión...',
    tours_filter_all: 'Todas las categorías',
    tours_found: 'excursiones encontradas',
    tours_no_results: 'No se encontraron excursiones',
    tours_clear_filters: 'Limpiar filtros',
    tours_from: 'Desde',
    tours_person: '/ persona',
    tours_spots: 'cupos',
    tours_hours: 'horas',
    tours_options: 'opciones disponibles',
    tours_reserve: 'Reservar',
    tours_view_options: 'Ver Opciones',
    tours_view_all: 'Ver Todas',
    tours_best_seller: 'Más vendido',
    tours_new: 'Nuevo',
    tours_offer: 'Oferta',
    
    // Tour Detail
    tour_back: 'Volver a excursiones',
    tour_effort: 'Esfuerzo',
    tour_select_option: 'Selecciona tu opción',
    tour_whatsapp: 'Reservar por WhatsApp',
    tour_pay: 'Pagar Ahora',
    tour_itinerary: 'Itinerario',
    tour_includes: 'Incluye',
    tour_not_includes: 'No Incluye',
    tour_bring: 'Llevar',
    tour_wear: 'Vestir',
    tour_info: 'Info',
    tour_itinerary_title: 'Itinerario del Día',
    tour_what_bring: 'Qué Llevar',
    tour_what_wear: 'Qué Vestir',
    tour_safety: 'Seguridad y Reglas',
    tour_pickup: 'Zonas de Recogida',
    tour_description: 'Descripción Completa',
    
    // Reserve Modal
    reserve_title: 'Reservar',
    reserve_name: 'Nombre',
    reserve_phone: 'WhatsApp',
    reserve_persons: 'Personas',
    reserve_date: 'Fecha',
    reserve_hotel: 'Hotel / Zona',
    reserve_send: 'Enviar a WhatsApp',
    
    // Reviews
    reviews_title: 'Lo Que Dicen Nuestros Viajeros',
    reviews_subtitle: 'Experiencias reales de clientes satisfechos',
    
    // FAQ
    faq_title: 'Preguntas Frecuentes',
    faq_subtitle: 'Resolvemos tus dudas',
    
    // Footer
    footer_description: 'Tu agencia de excursiones de confianza en República Dominicana. Experiencias únicas en el Caribe.',
    footer_tours: 'Excursiones Populares',
    footer_contact: 'Contacto',
    footer_follow: 'Síguenos',
    footer_rights: 'Todos los derechos reservados',
    footer_created: 'Creado por',
    
    // Contact
    contact_title: 'Contáctanos',
    contact_subtitle: '¿Tienes preguntas? Estamos aquí para ayudarte',
    contact_address: 'Dirección',
    contact_phone: 'Teléfono',
    contact_email: 'Email',
    
    // Categories
    cat_playa: 'Playa',
    cat_aventura: 'Aventura',
    cat_cultura: 'Cultura',
    cat_snorkel: 'Snorkel',
    cat_naturaleza: 'Naturaleza',
    cat_fiesta: 'Fiesta',
    
    // Effort levels
    effort_bajo: 'bajo',
    effort_medio: 'medio',
    effort_alto: 'alto',
    
    // Home Page Sections
    home_tours_subtitle: 'Descubre el Paraíso',
    home_tours_title: 'Excursiones Más Famosas',
    home_tours_description: 'Desde playas paradisíacas hasta aventuras en la naturaleza, tenemos la excursión perfecta para ti.',
    home_view_all: 'Ver Todas las Excursiones',
    home_reviews_subtitle: 'Testimonios',
    home_reviews_title: 'Reseñas Destacadas',
    home_reviews_note: '(Reseñas destacadas - montaje ilustrativo)',
    home_cta_title: '¿Listo para tu Aventura Caribeña?',
    home_cta_description: 'Reserva ahora y vive la experiencia más inolvidable de tus vacaciones. Te esperamos en el paraíso.',
    home_cta_btn: 'Reservar Ahora',
    home_reviews_rating: 'de promedio en reseñas',
    
    // CTA Section
    cta_title: '¿Listo para tu Aventura?',
    cta_description: 'Reserva ahora y vive experiencias inolvidables en el Caribe dominicano.',
    cta_btn_tours: 'Ver Excursiones',
    cta_btn_whatsapp: 'WhatsApp',
    
    // About Section
    about_subtitle: '¿Por qué elegirnos?',
    about_title: 'Quiénes Somos',
    
    // Features
    feature_transport: 'Transporte Seguro',
    feature_transport_desc: 'Vehículos modernos y conductores certificados',
    feature_guides: 'Guías Expertos',
    feature_guides_desc: 'Bilingües y conocedores del destino',
    feature_safety: 'Seguridad Total',
    feature_safety_desc: 'Equipos certificados y seguros incluidos',
    feature_reviews: 'Mejor Valorados',
    feature_reviews_desc: '+500 reseñas 5 estrellas',
  },
  en: {
    // Navbar
    nav_inicio: 'Home',
    nav_excursiones: 'Tours',
    nav_reservar: 'Book',
    nav_admin: 'Admin',
    nav_contacto: 'Contact',
    nav_whatsapp: 'Book WhatsApp',
    
    // Hero
    hero_subtitle: 'Welcome to the Caribbean',
    hero_title: 'Unforgettable Tours in Dominican Republic',
    hero_description: 'Safe transportation, expert guides and premium experiences. Discover the most beautiful beaches in the Caribbean.',
    hero_btn_tours: 'View Tours',
    hero_btn_reserve: 'Book Now',
    
    // Tours
    tours_title: 'Our Tours',
    tours_subtitle: 'Explore the Dominican Caribbean',
    tours_description: 'Discover the best tours in Dominican Republic. Paradise beaches, adventures, culture and much more.',
    tours_search: 'Search tour...',
    tours_filter_all: 'All categories',
    tours_found: 'tours found',
    tours_no_results: 'No tours found',
    tours_clear_filters: 'Clear filters',
    tours_from: 'From',
    tours_person: '/ person',
    tours_spots: 'spots',
    tours_hours: 'hours',
    tours_options: 'options available',
    tours_reserve: 'Book',
    tours_view_options: 'View Options',
    tours_view_all: 'View All',
    tours_best_seller: 'Best Seller',
    tours_new: 'New',
    tours_offer: 'Sale',
    
    // Tour Detail
    tour_back: 'Back to tours',
    tour_effort: 'Effort',
    tour_select_option: 'Select your option',
    tour_whatsapp: 'Book via WhatsApp',
    tour_pay: 'Pay Now',
    tour_itinerary: 'Itinerary',
    tour_includes: 'Includes',
    tour_not_includes: 'Not Included',
    tour_bring: 'Bring',
    tour_wear: 'Wear',
    tour_info: 'Info',
    tour_itinerary_title: 'Day Itinerary',
    tour_what_bring: 'What to Bring',
    tour_what_wear: 'What to Wear',
    tour_safety: 'Safety Rules',
    tour_pickup: 'Pickup Zones',
    tour_description: 'Full Description',
    
    // Reserve Modal
    reserve_title: 'Book',
    reserve_name: 'Name',
    reserve_phone: 'WhatsApp',
    reserve_persons: 'People',
    reserve_date: 'Date',
    reserve_hotel: 'Hotel / Area',
    reserve_send: 'Send to WhatsApp',
    
    // Reviews
    reviews_title: 'What Our Travelers Say',
    reviews_subtitle: 'Real experiences from satisfied customers',
    
    // FAQ
    faq_title: 'Frequently Asked Questions',
    faq_subtitle: 'We answer your questions',
    
    // Footer
    footer_description: 'Your trusted tour agency in Dominican Republic. Unique experiences in the Caribbean.',
    footer_tours: 'Popular Tours',
    footer_contact: 'Contact',
    footer_follow: 'Follow Us',
    footer_rights: 'All rights reserved',
    footer_created: 'Created by',
    
    // Contact
    contact_title: 'Contact Us',
    contact_subtitle: 'Have questions? We are here to help',
    contact_address: 'Address',
    contact_phone: 'Phone',
    contact_email: 'Email',
    
    // Categories
    cat_playa: 'Beach',
    cat_aventura: 'Adventure',
    cat_cultura: 'Culture',
    cat_snorkel: 'Snorkel',
    cat_naturaleza: 'Nature',
    cat_fiesta: 'Party',
    
    // Effort levels
    effort_bajo: 'low',
    effort_medio: 'medium',
    effort_alto: 'high',
    
    // Home Page Sections
    home_tours_subtitle: 'Discover Paradise',
    home_tours_title: 'Most Famous Tours',
    home_tours_description: 'From paradise beaches to nature adventures, we have the perfect tour for you.',
    home_view_all: 'View All Tours',
    home_reviews_subtitle: 'Testimonials',
    home_reviews_title: 'Featured Reviews',
    home_reviews_note: '(Featured reviews - illustrative montage)',
    home_cta_title: 'Ready for Your Caribbean Adventure?',
    home_cta_description: 'Book now and live the most unforgettable experience of your vacation. We are waiting for you in paradise.',
    home_cta_btn: 'Book Now',
    home_reviews_rating: 'average rating',
    
    // CTA Section
    cta_title: 'Ready for Your Adventure?',
    cta_description: 'Book now and experience unforgettable moments in the Dominican Caribbean.',
    cta_btn_tours: 'View Tours',
    cta_btn_whatsapp: 'WhatsApp',
    
    // About Section
    about_subtitle: 'Why choose us?',
    about_title: 'About Us',
    
    // Features
    feature_transport: 'Safe Transportation',
    feature_transport_desc: 'Modern vehicles and certified drivers',
    feature_guides: 'Expert Guides',
    feature_guides_desc: 'Bilingual and destination experts',
    feature_safety: 'Total Safety',
    feature_safety_desc: 'Certified equipment and insurance included',
    feature_reviews: 'Top Rated',
    feature_reviews_desc: '+500 five-star reviews',
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('language');
    return saved || 'es';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  const t = (key) => {
    return translations[language][key] || translations['es'][key] || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'es' ? 'en' : 'es');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
